import { render } from "./StaffDashboard.vue?vue&type=template&id=660d3be8&scoped=true"
import script from "./StaffDashboard.vue?vue&type=script&lang=js"
export * from "./StaffDashboard.vue?vue&type=script&lang=js"

import "./StaffDashboard.vue?vue&type=style&index=0&id=660d3be8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-660d3be8"]])

export default __exports__